import React from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

interface DetailContentCardProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  iconBgColor?: string;
  sx?: SxProps<Theme>;
}

/**
 * Reusable content card for detail screens
 * Used for description sections, info blocks, etc.
 */
export const DetailContentCard: React.FC<DetailContentCardProps> = ({
  title,
  children,
  icon,
  iconBgColor = "primary.main",
  sx,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        ...sx,
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 2,
          }}
        >
          {icon && (
            <Box
              sx={{
                bgcolor: iconBgColor,
                borderRadius: 2,
                p: 1.5,
                display: "flex",
              }}
            >
              {icon}
            </Box>
          )}
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        {children}
      </CardContent>
    </Card>
  );
};
